import React from 'react';
import { Link } from 'react-router-dom';
import NationalEmblem from './../../../assets/svg_main/national-emblem-clean-bg.svg';
import BackIcon from './../../../assets/svg_main/chevron-left.svg';
import ActiveArrowIcon from './../../../assets/svg_main/ActiveArrow.svg';
import './Navigation.css';
import UnicefIconOne from './../../../assets/png/UNICEF One.png';

interface menuType {
  name: string;
  path: string;
  icon: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  routeName: string;
}

interface NavigationProps {
  navigationMenu: menuType[];
  currentRoute: string;
  setCurrentRoute: (currentRoute: string) => void;
  isReportPage?:boolean;
  isbackButton?:boolean;
}

const Navigation = (props: NavigationProps) => {
  const { navigationMenu, setCurrentRoute, currentRoute,isReportPage,isbackButton } = props;
  return (
    <div className="app-navigation">
      <div className={`logo-wrapper ${isReportPage? "reportPage" : ""}`}>
        <NationalEmblem className="logo" />
        <div className="name-wrapper">
          <div className="name-wrapper-title">JANANI</div>
          <div className="name-wrapper-subtext">
            Journey of Antenatal, Natal and Neonatal Integrated Care
          </div>
          <div className="name-wrapper-subtext"style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
        </div>
      </div>
      <Link to={'/landing-page'} className="back-to">
        <BackIcon />
        <div className="back-to-name">{!isbackButton ? 'Common Master' : 'Back'}</div>
      </Link>
      <div className="navigation-menu">
        {navigationMenu.map((item, i) => {
          return (
            <Link
              to={item.path}
              onClick={() => setCurrentRoute(item.routeName)}
              className={`navigation-item ${item.routeName === currentRoute ? 'active' : ''}`}
              key={i}
            >
              <item.icon />
              <div className="navigation-item-name">{item.name}</div>
              {item.routeName === currentRoute && (
                <ActiveArrowIcon className="active-arrow" />
              )}
            </Link>
          );
        })}
      </div>
      <div className="logo-for-menu">
        <img className="unicef-logo-src-for-nav-menu" src={UnicefIconOne}/>
      </div>
    </div>
  );
};

export default Navigation;
